<h6 class="prd-h6"> Applicants </h6>
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card bg-light">
    <div class="card-body" *ngIf = 'displayState.workingDiv'>    
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
      </div>
</div>
<div *ngIf="displayState.editApplicantDiv" style="margin-top: 30px;">
    <div class="card bg-light col-md-8 offset-2">
        <div class="card-body">
        <!-- Applicant Name -->
            <div class="form-row">
                <label for="inputApplicantName" class="col-sm-2 col-form-label prd-label">Applicant</label>
                <div class="col-sm-5">
                    <input type="text" class="form-control form-control input-sm prd-required" id="inputApplicantName" maxlength="80"
                        placeholder="Applicant Name" [(ngModel)]="myApplicant.name">
                </div>
            </div> <!-- end row -->
            <br />
            <div class="form-row">
                <label class="col-sm-2 col-form-label prd-label">Address</label>
                <div class="col-sm-6">
                    <input type="text" class="form-control input-sm" maxlength="100"
                        placeholder="Street Address" [(ngModel)]="myApplicant.strAddr">
                </div>
            </div>
            <br />
            <div class="form-row">
                <label class="col-sm-2 col-form-label prd-label" maxlength="50">City</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control input-sm" maxlength="50" placeholder="City" [(ngModel)]="myApplicant.city">
                </div>
                <label class="col-sm-2 col-form-label prd-label">State</label>
                <div class="col-sm-1">
                    <input type="text" class="form-control input-sm" maxlength="2" placeholder="State" [(ngModel)]="myApplicant.state">
                </div>
                <label class="col-sm-1 col-form-label prd-label">Zip</label>
                <div class="col-sm-2">
                    <input type="text" class="form-control input-sm" maxlength="10" placeholder="Zip Code" [(ngModel)]="myApplicant.zip">
                </div>
            </div>
            <br />
            <div class="form-row">
                <label class="col-sm-2 col-form-label prd-label">Phone</label>
                <div class="col-sm-3">
                    <input type="tel" class="form-control input-sm prd-required" maxlength="18" placeholder="Phone" [(ngModel)]="myApplicant.phone">
                </div>
                <label class="col-sm-2 col-form-label prd-label">Alt Phone</label>
                <div class="col-sm-3">
                    <input type="text" class="form-control input-sm" maxlength="18" placeholder="Alternate Phone" [(ngModel)]="myApplicant.altPhone">
                </div>
            </div>
            <br />
            <div class="form-row">
                <label class="col-sm-2 col-form-label prd-label">Fax</label>
                <div class="col-sm-3">
                    <input type="text" class="form-control input-sm" maxlength="18" placeholder="Fax Number" [(ngModel)]="myApplicant.fax">
                </div>
                <label class="col-sm-2 col-form-label prd-label">Email</label>
                <div class="col-sm-5">
                    <input type="text" class="form-control input-sm" maxlength="50" placeholder="Email Address" [(ngModel)]="myApplicant.email">
                </div>
            </div>
            <br />
            <!-- Error Message -->
            <div class="col-sm-offset-3 col-sm-9 text-danger" *ngIf="displayState.errorMessage"><p>{{displayState.errorMessage}}</p>  </div>

            <!-- Buttons -->
            <div class="form-row">
                <div class="col-sm-offset-3 col-sm-9">
                    <button type="submit" class="btn btn-success offset-4" (click)="saveApplicant()" [disabled]="applicantNeedRequiredData()">Save</button>
                    <button type="submit" class="btn btn-warning offset-2" (click)="cancelEntry()">Cancel</button>
                </div>
            </div>

        </div>
    </div>

</div>

<div *ngIf="displayState.gridDiv">
    <div class="row">
        <div class="col-md-2">
            <button class="btn btn-sm btn-link" (click)="newApplicant()">New Applicant</button>
        </div>
    </div>
    <hr />
    <!-- GRID goes here-->
    <div class="col-md-12">
        <p-table #tabAgency [columns]="cols" [value]="applicantList" [responsive]="true" [scrollable]="true" scrollHeight="470px"  >
            <ng-template pTemplate="caption">
                &nbsp;&nbsp;&nbsp;
                <strong> Applicants </strong>
                <div class="ui-table-globalfilter-container">
                    <input type="text" pInputText size="40" [(ngModel)]="filterOptions.filterText" placeholder="Find Applicant - Global Filter" title="Enter text for which to search" (change)="tabAgency.filterGlobal($event.target.value, 'contains')" style="width:230px;">
                </div>
                    </ng-template>
            <ng-template pTemplate="header">
                <tr style="font-size:smaller">
                    <th style="width: 7%" >&nbsp;</th>
                    <th [pSortableColumn]="'name'" style="width: 20%">
                    Applicant Name
                    <p-sortIcon [field]="'name'"></p-sortIcon>
                </th>

                <th [pSortableColumn]="'strAddr'" style="width: 20%">
                    Street Address
                    <p-sortIcon [field]="'strAddr'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'city'" style="width: 10%">
                    City
                    <p-sortIcon [field]="'city'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'phone'" style="width: 10%">
                    Phone#
                    <p-sortIcon [field]="'phone'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'email'" style="width: 15%" >
                    Email
                    <p-sortIcon [field]="'email'"></p-sortIcon>
                </th>
                <th style="width: 7%" >&nbsp;</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-applicant>
                <tr style="font-size: small;">
                    <td style="width: 7%">
                        <button class='btn btn-sm btn-link' (click)="selectApplicant(applicant)">Select</button>
                    </td>
                    <td style="width: 20%">{{applicant.name}}</td>    
                    <td style="width: 20%">{{applicant.strAddr}}</td>
                    <td style="width: 10%">{{applicant.city}}</td>
                    <td style="width: 10%">{{applicant.phone}}</td>
                    <td style="width: 15%">{{applicant.email }}</td>
                    <td style="width: 7%">
                        <button class='btn btn-sm btn-link' (click)="deleteApplicant(applicant)">Delete</button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
